import { authHeader } from "../helpers/auth-header";
import axios from 'axios';

/**
 * Get list request API
 * @returns {Promise<T>}
 */
const getList = () => {
    return axios.get('/api/networkdevices', {headers: authHeader()})
        .then(res => {
            return res.data;
        });
};

/**
 * Get element by request API
 * @param id
 * @returns {Promise<T>}
 */
const getItemById = (id) => {
    return axios.get(`/api/networkdevices/${id}`, { headers: authHeader() })
        .then(res => {
            return res.data;
        });
};

/**
 * Get element
 * @returns {Promise<AxiosResponse<any>>}
 */
const getDropdownList = () => {
   return axios.get(`/api/networkdevices/getdropdownList`, { headers: authHeader() })
       .then(res => {
           return res.data;
       })
}

/**
 * Get simple model by request API
 * @param id
 */
const getSimpleInfo = (id) => {
    return axios.get(`/api/networkdevices/SimpleGetById/${id}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

/**
 * Set diagnostic Mode request API
 * @param deviceId
 * @param diagnosticModeVal
 * @returns {Promise<T>}
 */
const setDiagnosticMode = (deviceId, diagnosticModeVal) => {
    return axios.patch(`/api/networkdevices/SetDiagnosticMode/${deviceId}/${diagnosticModeVal}`, {}, {headers: authHeader() })
        .then(res => {
            return res.data
        })
};

/**
 * Set ignore schedule
 * @param deviceId
 * @param ignoreScheduleVal
 * @returns {Promise<AxiosResponse<any>>}
 */
const setIgnoreSchedule = (deviceId, ignoreScheduleVal) => {
    return axios.patch(`/api/networkdevices/SetIgnoreSchedule/${deviceId}/${ignoreScheduleVal}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

/**
 * Set audit mode request API
 * @param deviceId
 * @param auditModeVal
 * @returns {Promise<T>}
 */
const setAuditMode = (deviceId, auditModeVal) => {
    return axios.patch(`/api/networkdevices/SetAudit/${deviceId}/${auditModeVal}`, {}, { headers: authHeader() })
        .then(res => {return res.data})
};

/**
 * Set diagnostic Mode all devices request API
 * @param deviceId
 * @param diagnosticModeVal
 * @returns {Promise<T>}
 */
const setDiagnosticModeAllDevices = (diagnosticModeVal) => {
    return axios.patch(`/api/networkdevices/SetDiagnosticMode/${diagnosticModeVal}`, {}, {headers: authHeader() })
        .then(res => {
            return res.data
        })
};


/**
 * Reset button request API
 * @param deviceId
 * @returns {Promise<T>}
 */
const restart = (deviceId) => {
    return axios.get(`/api/networkdevices/Restart/${deviceId}`, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

/**
 * Shutdown request API
 * @param pcId
 * @returns {Promise<T>}
 */
const shutdownPc = (pcId) => {
    return axios.patch(`/api/networkdevices/turnoff/${pcId}`,{} , { headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const powerOnPc = (pcId) => {
    return axios.patch(`/api/networkdevices/turnon/${pcId}`, {}, { headers: authHeader() })
        .then(res => {
            return res.adata
        })
};

/**
 * Adding network devices request API
 * @param device
 * @returns {Promise<T>}
 */
const addNetworkDevice = (device = {}) => {
    return axios.post(`/api/networkdevices/`, device, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};


/**
 * Adding neatwork devices list form imports
 * @param devices
 * @returns {Promise<AxiosResponse<any>>}
 */
const addNetworkDevices = (devices = []) => {
    return axios.post(`/api/networkdevices/import`, devices, { headers: authHeader() })
        .then(res => res.data);
}

/**
 * Editing network devices request API
 * @param device
 */
const editNetworkDevice = (device = {}) => {
    return axios.patch(`/api/networkdevices/${device.id}`, device, { headers: authHeader() })
        .then(res => {
            return res.data
        });
};

/**
 * Removing network device request API
 * @param device
 * @returns {Promise<T>}
 */
const removeNetworkDevice = (deviceId = {}) => {
    return axios.delete(`/api/networkdevices/${deviceId}`, { headers: authHeader() })
        .then(res => {
            return res.data
        })
};

/**
 * Resynchronize device request API
 * @param deviceId
 */
const resynchronizeAll = (deviceId) => {
    return axios.patch(`/api/networkdevicescontent/ResynchronizeAll/${deviceId}`, {}, {headers: authHeader()})
        .then(res => {
            return res.data
        });
};

const getSoftwareVersions = () => {
    return axios.get(`/api/networkdevices/GetSoftwareVersions`, { headers: authHeader() })
        .then(res => {
            return res.data
        });
}

const updateSoftForDevice = (networkDeviceId, selectedVersion) => {
    return axios.post(`/api/networkdevices/UpdateSoftForDevice/${networkDeviceId}/${selectedVersion}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        });
}

const updateSoftForDevices = (networkDeviceIds, selectedVersion) => {
    return axios.post(`/api/networkdevices/UpdateSoftForDevices/${selectedVersion}`, networkDeviceIds, { headers: authHeader() })
        .then(res => {
            return res.data
        });
}

const toggleAgentDeviceInfo = (toggleAction) => {
    return axios.patch(`/api/networkdevices/SetDeviceInfo/${toggleAction}`, {}, { headers: authHeader() })
        .then(res => {
            return res.data
        })
}

export const networkDeviceService = {
    getList,
    getItemById,
    getSimpleInfo,
    getDropdownList,
    setDiagnosticMode,
    setIgnoreSchedule,
    setAuditMode,
    setDiagnosticModeAllDevices,
    restart,
    shutdownPc,
    powerOnPc,
    addNetworkDevice,
    addNetworkDevices,
    editNetworkDevice,
    removeNetworkDevice,
    resynchronizeAll,
    getSoftwareVersions,
    updateSoftForDevice,
    updateSoftForDevices,
    toggleAgentDeviceInfo
};
